// extracted by mini-css-extract-plugin
export default {"MapSelectorBox":"MapLayerSelector_MapSelectorBox__-v5-a"};